<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                title="My Asset"
                btnTitle="Add New"
                :showAddNew="false"
            />
        </div>

        <div class="px-2">
           <div class="row">
             <DateQuerySetter
                 btnTitle="Go"
                 @onClickGo="getAssetRegisterList"
                 class="tds-vds-query-setter"
             >
               <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                 <label for="colFormLabel" class="col-form-label">Group: </label>
                 <AsyncSelect
                     placeholder="Select Group"
                     v-model="selectGroup"
                     :api-service="fetchProductList"
                     :format-label="option => option.text"
                     label="text"
                     :additional-query="{ product_type: 'fixed_assets', group_level:1 }"
                 />
               </div>

               <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                 <label for="colFormLabel" class="col-form-label">Class Name: </label>
                 <AsyncSelect
                     placeholder="Select Class Name"
                     v-model="selectedProduct"
                     :api-service="fetchProductList"
                     :format-label="option => option.text"
                     label="text"
                     :additional-query="{ product_type: 'fixed_assets' }"
                 />
               </div>

               <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                 <label for="colFormLabel" class="col-form-label">Location: </label>
                 <AsyncSelect
                     placeholder="Select Location"
                     v-model="businessLocation"
                     :api-service="fetchBusinessLocationsList"
                     label="text"
                     :format-label="option => option.text"
                     :additional-query="{ location_type: 'fixed_assets' }"
                 />
               </div>

               <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                 <label for="colFormLabel" class="col-form-label">Department: </label>
                 <AsyncSelect
                     placeholder="Select Department"
                     v-model="department"
                     :api-service="fetchDepartmentList"
                     :format-label="option => option.name"
                     label="name"
                 />
               </div>
             </DateQuerySetter>
           </div>
        </div>

        <div class="d-flex justify-content-end mx-2" style="position: relative; z-index: 10;">
          <button
              class="btn btn-outline-primary btn-sm me-2 cursor-pointer"
              type="button"
              :class="{ active: viewMode === 'list' }"
              @click="setViewMode('list')"
          >
            <i class="fas fa-list"></i> List
          </button>
          <button
              class="btn btn-outline-primary btn-sm cursor-pointer"
              type="button"
              :class="{ active: viewMode === 'grid' }"
              @click="setViewMode('grid')"
          >
            <i class="fas fa-th"></i> Grid
          </button>
        </div>

        <div class="col-12 px-2 mt-1 mb-3" v-if="viewMode === 'list'">
          <div class="card" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>Asset ID</th>
                  <th>Tag Status</th>
                  <th>Name</th>
                  <th>Asset Class</th>
                  <th>Asset Location</th>
                  <th>Capitalization Date</th>
                  <th>Bill Date</th>
                  <th>Asset Value</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in assetRegisterList" :key="i">
                  <td>{{ item.id }}</td>
                  <td>No</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.product_name }}</td>
                  <td>{{ item.business_location_name }}</td>
                  <td>{{ item.format_capitalization_date }}</td>
                  <td>{{ item.format_bill_date }}</td>
                  <td>{{ item.asset_value }}</td>
                </tr>
                </tbody>
              </table>
              <p v-if="!assetRegisterList.length" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

         <div class="col-12 px-2 my-2 mb-3" v-if="viewMode === 'grid'">
           <div class="row g-4 mb-3">
          <div
              v-for="(item, i) in assetRegisterList"
              :key="i"
              class="col-xl-3 col-lg-4 col-md-6 col-sm-12"
          >
            <div class="employee-card">
              <div class="pt-1 mx-1 d-flex flex-column">
                <div>
                  <p class="d-block"><span class="fw-bolder">Asset Id:</span> {{ item.id }}</p>
                  <p class="d-block"><span class="fw-bolder">Name:</span> {{ item.name }}</p>
                  <p class="d-block"><span class="fw-bolder">Asset Class:</span> {{ item.product_name }}</p>
                  <p class="d-block"><span class="fw-bolder">Asset Location:</span> {{ item.business_location_name }}</p>
                  <p class="d-block"><span class="fw-bolder">Capitalization Date:</span> {{ item.format_capitalization_date }}</p>
                  <p class="d-block"><span class="fw-bolder">Bill Date:</span> {{ item.format_bill_date }}</p>
                  <p class="d-block"><span class="fw-bolder">Asset Value:</span> {{ item.asset_value }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
           <p v-if="!assetRegisterList.length" class="text-center mt-5">No data</p>

      </div>

      <div class="px-2">
        <Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/>
      </div>

        <GlobalLoader />
    </div>

</template>

<script setup>
import { ref, computed  } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import handleAssetRegister from '@/services/modules/assetRegister/assetRegister'
import TitleButton from '@/components/atom/TitleButton'
import Pagination from '@/components/atom/Pagination'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handlePurchaseAndSales from "@/services/modules/purchase";
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleBusinessesLocations from '@/services/modules/businessesLocations'
import handleDepartments from "@/services/modules/procurement/organization-settings/department";

const router = useRouter()
const store = useStore()
let offset = ref(20)
let assetRegisterList = ref([])
const route = useRoute()
let contactProfile = ref(null)
let billNumber = ref(null)
const selectedProduct = ref(null);
const selectGroup = ref(null);
const businessLocation = ref(null);
const department = ref(null);

const { fetchAssetRegister } = handleAssetRegister()
const { fetchProductList } = handlePurchaseAndSales()
const { fetchBusinessLocationsList } = handleBusinessesLocations()
const { fetchDepartmentList } = handleDepartments()

const companyId = computed(() => {
    return route.params.companyId
})
const viewMode = ref('list')
const setViewMode = (mode) => {
  viewMode.value = mode
}
function getQuery () {
  let queryStr = '?company_id=' + route.params.companyId + '&is_my_asset=1'
  queryStr += '&offset=' + offset.value
  if (route.query.page) queryStr += "&page=" + route.query.page;
  if(selectedProduct.value) queryStr += '&product_id=' + selectedProduct.value.id;
  if(selectGroup.value) queryStr += '&group_id=' + selectGroup.value.id;
  if(businessLocation.value) queryStr += '&business_location_id=' + businessLocation.value.id;
  if(department.value) queryStr += '&department_id=' + department.value.id;
  if (route.query.start) queryStr += '&start_date=' + route.query.start;
  if (route.query.end) queryStr += '&end_date=' + route.query.end;
  return queryStr
}
function getAssetRegisterList() {
    const query = getQuery();
    const queryString = new URLSearchParams(query);

  fetchAssetRegister("?" + queryString.toString())
    .then(res => {
        if (!res.status){
          assetRegisterList.value = []
          store.commit("resetPagination")
          return
        }
        assetRegisterList.value = res.data.data
        setPagination(res.data)
    })
}

function setPagination(data) {
    if(!data.data.length) return
    store.commit('setPaginationData', {
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

async function onPageChange(page) {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    getAssetRegisterList()
}

</script>

<style scoped>
.btn-outline-primary.active {
  background-color: #7367f0 !important;
  color: white !important;
  border-color: #7367f0 !important;
}

.btn-outline-primary:hover {
  background-color: #7367f0;
  color: white;
  border-color: #7367f0;
}

.employee-card {
  border: none;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.employee-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.employee-photo img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 3px solid #e9ecef;
}

.employee-info i {
  color: #6c757d;
}

.employee-info p {
  margin: 0;
  line-height: 1.4;
}

</style>
